import { Box, Skeleton } from "@mui/material"

export const CommentLoader = () => {
    return (
        <Box width="100%" display="flex" flexDirection="column" gap="12px">
           <Box width="100%" display="flex" alignItems="center" gap="12px">
                <Skeleton variant="circular" sx={{height: '38px', width: '43px', bgcolor: '#F2F6F9'}} />
                <Box width="100%">
                    <Skeleton variant="rounded" sx={{ height: '25px', width: '40%', bgcolor: '#F2F6F9' }} />
                </Box>
            </Box>
            <Skeleton variant="rounded" sx={{ height: '50px', width: '100%', bgcolor: '#F2F6F9' }} />
        </Box>
    )
};